import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'

/**
 * Функция удаления группы полей
 */
export const useRemoveInventObjectGroup = () => {
  const http = useHttp()

  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.del(`/manuals/object-types/group/${data.id}`)
    },
  })

  const remove = async (data: any) => {
    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.group_removed'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    remove,
  }
}
